import { LitElement, html, css } from 'lit';

export class CrusherSectionTitle extends LitElement {
  static styles = css`
    :host {
      display: block;
      margin-bottom: var(--crusher-section-title-margin-bottom, var(--crusher-spacing-10));
      position: relative;
      z-index: 1;
      text-align: start;
    }
    :host([align="center"]) {
      text-align: center;
    }
    :host([align="end"]) {
      text-align: end;
    }
    .title {
      display: inline-block;
      font-size: var(--crusher-section-title-font-size, var(--crusher-font-size-4xl));
      font-weight: var(--crusher-section-title-font-weight, var(--crusher-font-weight-bold));
      color: var(--crusher-section-title-color, var(--crusher-text-primary));
      position: relative;
      padding-bottom: var(--crusher-section-title-padding-bottom, calc(var(--crusher-spacing-4) + var(--crusher-spacing-2)));
      margin: 0;
      isolation: isolate;
    }
    :host([uppercase]) .title {
      text-transform: uppercase;
    }
    .kicker {
      display: block;
      margin: var(--crusher-section-title-kicker-margin, 0);
      color: var(--crusher-section-title-kicker-color, var(--crusher-color-brand-primary));
      font-size: var(--crusher-section-title-kicker-size, var(--crusher-font-size-base));
      font-weight: var(--crusher-section-title-kicker-weight, var(--crusher-font-weight-semibold));
      line-height: var(--crusher-section-title-kicker-line-height, 1.2);
      text-transform: var(--crusher-section-title-kicker-transform, none);
    }
    .title::before {
      content: '';
      position: absolute;
      height: var(--crusher-section-title-line-height, calc(var(--crusher-focus-width) * 2));
      width: var(--crusher-section-title-line-primary-width, calc(var(--crusher-spacing-12) + (var(--crusher-spacing-1) / 2)));
      background-color: var(--crusher-section-title-line-color, var(--crusher-color-brand-primary));
      left: 0;
      bottom: var(--crusher-section-title-line-primary-bottom, var(--crusher-spacing-2));
      border-radius: var(--crusher-section-title-line-radius, var(--crusher-radius-full));
    }
    .title::after {
      content: '';
      position: absolute;
      height: var(--crusher-section-title-line-height, calc(var(--crusher-focus-width) * 2));
      width: var(--crusher-section-title-line-secondary-width, calc(var(--crusher-spacing-6) + (var(--crusher-focus-width) / 2)));
      background-color: var(--crusher-section-title-line-color, var(--crusher-color-brand-primary));
      left: 0;
      bottom: var(--crusher-section-title-line-secondary-bottom, 0);
      border-radius: var(--crusher-section-title-line-radius, var(--crusher-radius-full));
    }
    :host([line="none"]) .title {
      padding-bottom: var(--crusher-section-title-padding-bottom, 0);
    }
    :host([line="none"]) .title::before,
    :host([line="none"]) .title::after {
      display: none;
    }
  `;

  static properties = {
    kicker: { type: String },
  };

  constructor() {
    super();
    this.kicker = '';
  }

  render() {
    return html`
      <h2 class="title">
        ${this.kicker ? html`<span class="kicker">${this.kicker}</span>` : ''}
        <slot></slot>
      </h2>
    `;
  }
}

customElements.define('crusher-section-title', CrusherSectionTitle);
